import { APIKey } from '@shared/api';
import apiKeyHelpers from '@shared/api/lib/helpers/apiKeys.helper';

export const getKeyType = (apiKey: APIKey) => apiKeyHelpers.getKeyTypeFromKey(apiKey);
